"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const utilitycaution = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 64 66",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-utilitycaution` : '') + (description ? ` desc-utilitycaution` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-utilitycaution"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-utilitycaution"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.62 61.8A5.7 5.7 0 0 1 2 56.03c0-.9.2-1.77.59-2.58L26.97 7.33a5.56 5.56 0 0 1 10.06 0L61.4 53.45a5.84 5.84 0 0 1-2.52 7.74c-.77.4-1.64.61-2.51.61H7.63Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.57 22.92c-.1-1.17.57-2.1 1.68-2.1h3.44c1.1 0 1.83.93 1.73 2.1l-.3 16.32c-.1 1.07-2.19 1.76-3.14 1.76-.96 0-2.92-.68-3.02-1.76l-.39-16.32Zm3.4 21.64a3.3 3.3 0 0 1 3.4 3.36v.5a3.3 3.3 0 0 1-3.4 3.36 3.3 3.3 0 0 1-3.4-3.37v-.49c0-1.9 1.48-3.36 3.4-3.36Z",
    fill: "#8F6600"
  }));
};
var _default = exports.default = utilitycaution;